import { Trans, useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { WrapModalProps, wrapModalPromise } from '@/utils';

import styles from './index.module.scss';
import Button from '@/components/Button';
import { Issue } from '../IssueSelect/hooks';
import { useRemainingVote } from '../PrimePostVoteBtn/hooks';
import { useCurrentAddressInfo } from '@/hooks';

type Props = {};

export const PrimeVoteCountModal = ({ hide }: Props & WrapModalProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('PrimeVoteCountTip.19ttste')}</div>
      <div className={styles.content}>
        <div>
          <Trans i18nKey="PrimeVoteCountTip.92z0o8" values={{ amount: 0 }}>
            My remaining votes:
            <span className={styles.num}>0</span>
          </Trans>
        </div>
        <div className={styles.desc}>{t('PrimeVoteCountTip.1h40ihj')}</div>
      </div>
      <div className={styles.btnContainer}>
        <Button type="primary" className={styles.btn} onClick={() => hide()}>
          {t('PrimeVoteCountTip.1gppw')}
        </Button>
      </div>
    </div>
  );
};

export const openPrimeVoteCountModal = wrapModalPromise<Props>(PrimeVoteCountModal, {
  containerClassName: styles.modalContainer,
});

export const PrimeVoteStatus = ({ issue }: { issue?: Issue }) => {
  const { t } = useTranslation();
  const { userInfo } = useCurrentAddressInfo();
  const isProgressIssue = useMemo(() => issue?.status === 'ongoing', [issue?.status]);
  const { data: remainingVote } = useRemainingVote();

  return (
    <div className={styles.voteStatus}>
      <div className={styles.ends}>
        {isProgressIssue
          ? t('PrimeVoteCountTip.ends', { endTime: issue?._endTime })
          : issue?.duration}
      </div>
      {isProgressIssue ? (
        <div className={styles.remaining}>
          {t('PrimeVoteCountTip.13bx8en', {
            amount: userInfo?.web3_id ? remainingVote?.remaining_count : 0,
          })}
        </div>
      ) : null}
    </div>
  );
};
